// Needed for testing only

export default {
  "vueform": {
    "elements": {
      "list": {
        "add": "+ إضافة",
        "remove": "&times;"
      },
      "file": {
        "defaultName": "File",
        "dndTitle": "رفع ملف",
        "dndDescription": "قم بإسقاط الملف أو انقر هنا للرفع",
        "removeConfirm": "عند إزالة الملف، سيتم حذفه نهائيًا. هل أنت متأكد من الاستمرار؟",
        "select": "اختر ملفًا",
        "upload": "رفع"
      },
      "multifile": {
        "uploadButton": "رفع ملفات",
        "dndTitle": "رفع ملفات",
        "dndDescription": "قم بإسقاط الملفات أو انقر هنا للرفع"
      },
      "gallery": {
        "uploadButton": "رفع صور",
        "dndTitle": "رفع صور",
        "dndDescription": "قم بإسقاط الصور أو انقر هنا للرفع"
      },
      "phone": {
        "ariaLabel": "اختر دولة"
      },
      "signature": {
        "type": "كتابة",
        "draw": "رسم",
        "upload": "رفع",
        "font": "اختر الخط",
        "fontPlaceholder": "Your Name",
       "placeholder": "وقّع هنا",
        "unsupportedFormat": "تنسيق الملف غير مدعوم. الامتدادات المقبولة هي: :extensions"
      }
    },
    "steps": {
      "finish": "إنهاء",
      "next": "التالي",
      "previous": "السابق"
    },
    "editor": {
      "acceptedMimesError": "الأنواع المقبولة هي: :mimes",
      "acceptedExtensionsError": "الامتدادات المقبولة هي: :extensions"
    },
    "datepicker": {
      "weekdays": {
        "shorthand": [
          "Sun",
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat"
        ],
        "longhand": [
          "الأحد",
          "الإثنين",
          "الثلاثاء",
          "الأربعاء",
          "الخميس",
          "الجمعة",
          "السبت"
        ]
      },
      "months": {
        "shorthand": [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        "longhand": [
          "يناير",
          "فبراير",
          "مارس",
          "أبريل",
          "مايو",
          "يونيو",
          "يوليو",
          "أغسطس",
          "سبتمبر",
          "أكتوبر",
          "نوفمبر",
          "ديسمبر"
        ]
      },
      "daysInMonth": [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ],
      "firstDayOfWeek": 0,
      "ordinal": function (nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch (s % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      },
      "rangeSeparator": " إلى ",
      "weekAbbreviation": "Wk",
      "scrollTitle": "قم بالتمرير للزيادة",
      "toggleTitle": "انقر للتبديل",
      "amPM": [
        "ص",
        "م"
      ],
      "yearAriaLabel": "السنة",
      "monthAriaLabel": "الشهر",
      "hourAriaLabel": "الساعة",
      "minuteAriaLabel": "الدقيقة"
    },
    "dateFormats": {
      "datetimeSeconds24": "YYYY-MM-DD HH:mm:ss",
      "datetimeSeconds12": "YYYY-MM-DD hh:mm:ss a",
      "datetime24": "YYYY-MM-DD HH:mm",
      "datetime12": "YYYY-MM-DD hh:mm a",
      "timeSeconds24": "HH:mm:ss",
      "timeSeconds12": "hh:mm:ss a",
      "time24": "HH:mm",
      "time12": "hh:mm a",
      "date": "YYYY-MM-DD"
    },
    "multiselect": {
      "multipleLabelOne": "تم اختيار خيار واحد",
      "multipleLabelMore": "تم اختيار :options خيارات",
      "noResults": "لم يتم العثور على خيارات",
      "noOptions": "القائمة فارغة"
    },
    "defaultMessage": "حقل غير صالح",
    "a11y": {
      "file": {
        "description": "اضغط على Backspace للإزالة"
      },
      "list": {
        "remove": "زر إزالة العنصر"
      }
    },
    "countries": {
      "AF": "Afghanistan",
      "AL": "Albania",
      "DZ": "Algeria",
      "AS": "American Samoa",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AG": "Antigua & Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Ascension Island",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaijan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "Belgium",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivia",
      "BA": "Bosnia & Herzegovina",
      "BW": "Botswana",
      "BR": "Brazil",
      "IO": "British Indian Ocean Territory",
      "VG": "British Virgin Islands",
      "BN": "Brunei",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambodia",
      "CM": "Cameroon",
      "CA": "Canada",
      "CV": "Cape Verde",
      "BQ": "Caribbean Netherlands",
      "KY": "Cayman Islands",
      "CF": "Central African Republic",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "China",
      "CO": "Colombia",
      "KM": "Comoros",
      "CG": "Congo - Brazzaville",
      "CD": "Congo - Kinshasa",
      "CK": "Cook Islands",
      "CR": "Costa Rica",
      "CI": "Côte d’Ivoire",
      "HR": "Croatia",
      "CU": "Cuba",
      "CW": "Curaçao",
      "CY": "Cyprus",
      "CZ": "Czechia",
      "DK": "Denmark",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "EC": "Ecuador",
      "EG": "Egypt",
      "SV": "El Salvador",
      "GQ": "Equatorial Guinea",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Eswatini",
      "ET": "Ethiopia",
      "FK": "Falkland Islands (Islas Malvinas)",
      "FO": "Faroe Islands",
      "FJ": "Fiji",
      "FI": "Finland",
      "FR": "France",
      "GF": "French Guiana",
      "PF": "French Polynesia",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Germany",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Greece",
      "GL": "Greenland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hungary",
      "IS": "Iceland",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Iran",
      "IQ": "Iraq",
      "IE": "Ireland",
      "IL": "Israel",
      "IT": "Italy",
      "JM": "Jamaica",
      "JP": "Japan",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kyrgyzstan",
      "LA": "Laos",
      "LV": "Latvia",
      "LB": "Lebanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "Macao",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Marshall Islands",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "MX": "Mexico",
      "FM": "Micronesia",
      "MD": "Moldova",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Morocco",
      "MZ": "Mozambique",
      "MM": "Myanmar (Burma)",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Netherlands",
      "NC": "New Caledonia",
      "NZ": "New Zealand",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Norfolk Island",
      "KP": "North Korea",
      "MK": "North Macedonia",
      "MP": "Northern Mariana Islands",
      "NO": "Norway",
      "OM": "Oman",
      "PK": "Pakistan",
      "PW": "Palau",
      "PS": "Palestine",
      "PA": "Panama",
      "PG": "Papua New Guinea",
      "PY": "Paraguay",
      "PE": "Peru",
      "PH": "Philippines",
      "PL": "Poland",
      "PT": "Portugal",
      "PR": "Puerto Rico",
      "QA": "Qatar",
      "RE": "Réunion",
      "RO": "Romania",
      "RU": "Russia",
      "RW": "Rwanda",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "São Tomé & Príncipe",
      "SA": "Saudi Arabia",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "Sint Maarten",
      "SK": "Slovakia",
      "SI": "Slovenia",
      "SB": "Solomon Islands",
      "SO": "Somalia",
      "ZA": "South Africa",
      "KR": "South Korea",
      "SS": "South Sudan",
      "ES": "Spain",
      "LK": "Sri Lanka",
      "BL": "St. Barthélemy",
      "SH": "St. Helena",
      "KN": "St. Kitts & Nevis",
      "LC": "St. Lucia",
      "MF": "St. Martin",
      "PM": "St. Pierre & Miquelon",
      "VC": "St. Vincent & Grenadines",
      "SD": "Sudan",
      "SR": "Suriname",
      "SE": "Sweden",
      "CH": "Switzerland",
      "SY": "Syria",
      "TW": "Taiwan",
      "TJ": "Tajikistan",
      "TZ": "Tanzania",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad & Tobago",
      "TN": "Tunisia",
      "TR": "Türkiye",
      "TM": "Turkmenistan",
      "TC": "Turks & Caicos Islands",
      "TV": "Tuvalu",
      "VI": "U.S. Virgin Islands",
      "UG": "Uganda",
      "UA": "Ukraine",
      "AE": "United Arab Emirates",
      "GB": "United Kingdom",
      "US": "United States",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Vatican City",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "WF": "Wallis & Futuna",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    }
  },
  "validation": {
    "accepted": "يجب قبول :attribute.",
    "active_url": ":attribute ليس عنوان URL صالحًا.",
    "after": "يجب أن يكون :attribute تاريخًا بعد :date.",
    "after_or_equal": "يجب أن يكون :attribute تاريخًا بعد أو يساوي :date.",
    "alpha": "يجب يحتوي :attribute على أحرف فقط.",
    "alpha_dash": "يجب يحتوي :attribute على أحرف وأرقام وشرطات وشرطات سفلية فقط.",
    "alpha_num": "يجب يحتوي :attribute على أحرف وأرقام فقط.",
    "array": "يجب أن يكون :attribute مصفوفة.",
    "before": "يجب أن يكون :attribute تاريخًا قبل :date.",
    "before_or_equal": "يجب أن يكون :attribute تاريخًا قبل أو يساوي :date.",
    "between": {
      "numeric": "يجب أن يكون :attribute بين :min و :max.",
      "file": "يجب أن يكون :attribute بين :min و :max كيلوبايت.",
      "string": "يجب أن يكون :attribute بين :min و :max حرفًا.",
      "array": "يجب أن يحتوي :attribute على عناصر بين :min و :max."
    },
    "boolean": "يجب أن يكون حقل :attribute صحيحًا أو خاطئًا.",
    "captcha": "يرجى التحقق من أنك لست روبوتًا.",
    "completed": "يرجى إدخال رقم هاتف صالح.",
    "confirmed": "تأكيد :attribute غير متطابق.",
    "date": ":attribute ليس تاريخًا صالحًا.",
    "date_format": ":attribute لا يتطابق مع الصيغة :format.",
    "date_equals": "يجب أن يكون :attribute مساويًا لـ :date.",
    "different": "يجب أن يكون :attribute و :other مختلفين.",
    "digits": "يجب أن يتكون :attribute من :digits أرقام.",
    "digits_between": "يجب أن يكون :attribute بين :min و :max رقمًا.",
    "dimensions": ":attribute له أبعاد صورة غير صالحة.",
    "distinct": "حقل :attribute يحتوي على قيمة مكررة.",
    "email": "يجب أن يكون :attribute عنوان بريد إلكتروني صالحًا.",
    "exists": ":attribute المحدد غير صالح.",
    "file": "يجب أن يكون :attribute ملفًا.",
    "filled": "يجب أن يحتوي حقل :attribute على قيمة.",
    "gt": {
      "numeric": "يجب أن يكون :attribute أكبر من :value.",
      "file": "يجب أن يكون :attribute أكبر من :value كيلوبايت.",
      "string": "يجب أن يكون :attribute أكبر من :value حرفًا.",
      "array": "يجب أن يحتوي :attribute على أكثر من :value عنصر."
    },
    "gte": {
      "numeric": "يجب أن يكون :attribute أكبر من أو يساوي :value.",
      "file": "يجب أن يكون :attribute أكبر من أو يساوي :value كيلوبايت.",
      "string": "يجب أن يكون :attribute أكبر من أو يساوي :value حرفًا.",
      "array": "يجب أن يحتوي :attribute على :value عنصر أو أكثر."
    },
    "image": "يجب أن يكون :attribute صورة.",
    "in": ":attribute المحدد غير صالح.",
    "in_array": "حقل :attribute غير موجود في :other.",
    "integer": "يجب أن يكون :attribute عددًا صحيحًا.",
    "ip": "يجب أن يكون :attribute عنوان IP صالحًا.",
    "ipv4": "يجب أن يكون :attribute عنوان IPv4 صالحًا.",
    "ipv6": "يجب أن يكون :attribute عنوان IPv6 صالحًا.",
    "json": "يجب أن يكون :attribute سلسلة JSON صالحة.",
    "lt": {
      "numeric": "يجب أن يكون :attribute أقل من :value.",
      "file": "يجب أن يكون :attribute أقل من :value كيلوبايت.",
      "string": "يجب أن يكون :attribute أقل من :value حرفًا.",
      "array": "يجب أن يحتوي :attribute على أقل من :value عنصر."
    },
    "lte": {
      "numeric": "يجب أن يكون :attribute أقل من أو يساوي :value.",
      "file": "يجب أن يكون :attribute أقل من أو يساوي :value كيلوبايت.",
      "string": "يجب أن يكون :attribute أقل من أو يساوي :value حرفًا.",
      "array": "يجب ألا يحتوي :attribute على أكثر من :value عنصر."
    },
    "max": {
      "numeric": "يجب أن لا يكون :attribute أكبر من :max.",
      "file": "يجب أن لا يكون :attribute أكبر من :max كيلوبايت.",
      "string": "يجب أن لا يكون :attribute أكبر من :max حرفًا.",
      "array": "يجب أن لا يحتوي :attribute على أكثر من :max عنصر."
    },
    "mimes": "يجب أن يكون :attribute ملفًا من نوع: :values.",
    "mimetypes": "يجب أن يكون :attribute ملفًا من نوع: :values.",
    "min": {
      "numeric": "يجب أن يكون :attribute على الأقل :min.",
      "file": "يجب أن يكون :attribute على الأقل :min كيلوبايت.",
      "string": "يجب أن يكون :attribute على الأقل :min حرفًا.",
      "array": "يجب أن يحتوي :attribute على الأقل :min عنصر."
    },
    "not_in": ":attribute المحدد غير صالح.",
    "not_regex": "صيغة :attribute غير صالحة.",
    "numeric": "يجب أن يكون :attribute رقمًا.",
    "present": "يجب أن يكون حقل :attribute موجودًا.",
    "regex": "صيغة :attribute غير صالحة.",
    "required": "حقل :attribute مطلوب.",
    "required_if": "حقل :attribute مطلوب عندما يكون :other هو :value.",
    "required_unless": "حقل :attribute مطلوب ما لم يكن :other في :values.",
    "required_with": "حقل :attribute مطلوب عندما يكون :values موجودًا.",
    "required_with_all": "حقل :attribute مطلوب عندما تكون :values موجودة.",
    "required_without": "حقل :attribute مطلوب عندما لا يكون :values موجودًا.",
    "required_without_all": "حقل :attribute مطلوب عندما لا يكون أي من :values موجودًا.",
    "same": "يجب أن يتطابق :attribute و :other.",
    "size": {
      "numeric": "يجب أن يكون :attribute :size.",
      "file": "يجب أن يكون :attribute :size كيلوبايت.",
      "string": "يجب أن يكون :attribute :size حرفًا.",
      "array": "يجب أن يحتوي :attribute على :size عنصر."
    },
    "string": "يجب أن يكون :attribute سلسلة نصية.",
    "timezone": "يجب أن يكون :attribute منطقة زمنية صالحة.",
    "unique": "تم أخذ :attribute بالفعل.",
    "uploaded": "فشل تحميل :attribute.",
    "url": "صيغة :attribute غير صالحة.",
    "uuid": "يجب أن يكون :attribute UUID صالحًا.",
    "remote": "حقل :attribute غير صالح."
  }
}